import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, Form } from '@angular/forms';
import { Forms } from '../shared/classes/formModel';
import { Register } from '../shared/classes/registerModel';
import { UUID } from 'angular2-uuid';
import { ngxLoadingAnimationTypes, NgxLoadingComponent } from 'ngx-loading';
import { HttpClient } from '@angular/common/http';
declare var require: any;
import { AuthenticateService } from '../shared/services/authenticate.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import { FileUploadService } from 'src/app/shared/services/fileupload.service';
import { TokenStorageService } from '../shared/services/token.service';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.sass'],
  styles: [`
  ::ng-deep.mat-horizontal-stepper-header{
    pointer-events: none;
   }
  `]
})
export class RegistrationComponent implements OnInit {
  @ViewChild('ngxLoading') ngxLoadingComponent: NgxLoadingComponent;
  @ViewChild('customLoadingTemplate') customLoadingTemplate: TemplateRef<any>;
  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;
  heading = 'Registration Tool';
  subheading = 'fill all the details as per instructions';
  icon = 'pe-7s-wallet icon-gradient bg-plum-plate';
  settings: {};
  showList: boolean = true;
  showAddform: boolean = false;
  showStepper: boolean = false;
  type: string = 'save'
  index: number;
  registerForm: FormGroup;
  formTable: boolean = false;
  robj = {};
  formsArray = [];
  isFormBtn: any[] = [];
  showSavebtn: boolean;
  form: Forms[];
  register: Register;
  registrationName: string;
  url = '';
  public loading: boolean;
  registerIcon: any;
  showAdd: boolean = true;
  imageUploadService: any;
  globalImgUrl: string;
  farmerObject: any = [];
  landObject: any = [];
  chcObject: any = [];
  bazarObject: any = [];
  storageObject: any = [];
  loanObject: any = [];
  dealerObject: any = [];
  distributorObject: any = [];
  bankerObject: any = [];
  insuranceregObject: any = [];
  insuranceObject: any = [];
  farmmachineObject: any = [];
  serviceproviderObject: any = [];
  results: Object;
  registeredForms: any = [];
  hideFarmerForm: boolean = false;
  hidemachineForm: boolean = false;
  hideserviceProvider: boolean = false;
  hidechcForm: boolean = false;
  hidestorageForm: boolean = false;
  hideloanForm: boolean = false;
  hidedealerForm: boolean = false;
  hidedistributorForm: boolean = false;
  hideInsuranceForm: boolean = false;
  hideinsregForm: boolean = false;
  hidebankerForm: boolean = false;
  hideFarmerbazar: boolean = false
  hideLandForm: boolean = false;
  registerGroup: FormGroup;
  languageList: any = [];
  regLanguage: string = '';
  registerFormObj: { orderId: number; ask: string; type: string; response: string; kpi: boolean; kpiName?: string };
  registerFormUpdateObj: { orderId: number; ask: string; type: string; response: string; kpi: boolean; kpiName?: string }
  tableArray: any[];
  editRow: any[] = [];
  kpiName: string;
  showKpiName: boolean = false;
  groupName: any;
  tableName: any;
  showKpiNameUpdate = [];
  kpinameHead: boolean;
  previousPage: number;
  skip: number;
  collectionSize: number;
  page = 1;
  showReg: boolean = true;
  typeId: string = 'dynamic';
  selctedReg: string = '';
  editRowIndex: number;
  disableFormsBtn: boolean = false;
  selectedUUID: string = '';

  constructor(private formBuilder: FormBuilder,
    private authService: AuthenticateService,
    private tokenService : TokenStorageService,
    private fileUploadService:FileUploadService,
    public http: HttpClient) { }
  ngDoCheck() {
      this.globalImgUrl = this.authService.s3url();
      this.groupName = this.tokenService.getGroup();
  }
  ngOnInit() {
    this.languageList = [
      { languageName: 'Bengali', shortName: 'BN' },
      { languageName: 'English', shortName: 'EN' },
      { languageName: 'Gujarati', shortName: 'GU' },
      { languageName: 'Hindi', shortName: 'HI' },
      { languageName: 'Kannada', shortName: 'KN' },
      { languageName: 'Marathi', shortName: 'MR' },
      { languageName: 'Malayalam', shortName: 'ML' },
      { languageName: 'Odia', shortName: 'OR' },
      { languageName: 'Punjabi', shortName: 'PA' },
      { languageName: 'Tamil', shortName: 'TA' },
      { languageName: 'Telugu', shortName: 'TE' },
      { languageName: 'Urdu', shortName: 'UR' },
    ]
    this.registerGroup = this.formBuilder.group({
      orderId: ['', Validators.required],
      ask: ['', Validators.required], //Validators.pattern(".*\\S.*[a-zA-z0-9 ]")
      type: ['', Validators.required],
      response: ['', [Validators.required, Validators.pattern(".*\\S.*[a-zA-z0-9 ]")]],
      kpiName: [''],
      kpi: ['', Validators.required],
    });
    this.registerForm = this.formBuilder.group({
      registrationName: ['', Validators.required],
      regLanguage: ['', Validators.required]
    });
    // this.globalImgUrl = myApi.s3url;
    this.farmerObject = require('../shared/definedJsons/farmer.json');
    this.landObject = require('../shared/definedJsons/land.json');
    this.chcObject = require('../shared/definedJsons/chc.json');
    this.storageObject = require('../shared/definedJsons/service-provider.json');
    this.dealerObject = require('../shared/definedJsons/dealer.json');
    this.distributorObject = require('../shared/definedJsons/distributor.json');
    this.bazarObject = require('../shared/definedJsons/bazar.json');
    this.loanObject = require('../shared/definedJsons/loanReq.json');
    this.insuranceObject = require('../shared/definedJsons/insuranceReq.json');
    this.bankerObject = require('../shared/definedJsons/loan.json');
    this.insuranceregObject = require('../shared/definedJsons/insurance.json');
    this.farmmachineObject = require('../shared/definedJsons/farm-machine.json');
    this.serviceproviderObject = require('../shared/definedJsons/service-provider.json');
  }

  onImgError(event) {
    event.target.src = this.globalImgUrl + 'agri_logo.png';
  }

  loadPage(pageNumber: number) {
    this.loading = true;
    console.log("page number ", pageNumber, this.previousPage)
    if (pageNumber !== this.previousPage) {
      this.skip = (pageNumber * 20) - 20;
      this.previousPage = pageNumber;
      // this.loadData(this.skip);
    }
  }

  // loadData(skip) {
  //   var count = { match: { group: this.groupName } }
  //   this.registerService.getAllRegisteredFormscount(count).then((data: any) => {
  //     console.log("reg size : ", data)
  //     if (data.length > 0) {
  //       this.collectionSize = data[0].size
  //       var options = {
  //         group: this.groupName,
  //         options: {
  //           limit: 20,
  //           sortFields: { createTs: -1 },
  //           skip: skip
  //         }
  //       }
  //       this.registerService.getAllRegisteredForms(options).then((data: any) => {
  //         console.log("getregCount : ", data);
  //         if (data.length > 0) {
  //           this.registeredForms = data;
  //           this.loading = false;
  //         } else {
  //           this.loading = false;
  //         }
  //       });
  //     } else {
  //       this.loading = false;

  //     }
  //   });
  // }

  // getAllRegisteredForms() {
  //   this.loading = true;
  //   var count = { match: { group: this.groupName } }
  //   this.registerService.getAllRegisteredFormscount(count).then((data: any) => {
  //     console.log("COUNT : ", data);
  //     if (data.length > 0) {
  //       this.collectionSize = data[0].size
  //       var options = {
  //         group: this.groupName,
  //         options: {
  //           limit: 20,
  //           sortFields: { createTs: -1 },
  //           skip: 0
  //         }
  //       }
  //       this.registeredForms = [];
  //       this.registerService.getAllRegisteredForms(options).then((data: any) => {
  //         console.log("regData == ", data);
  //         if (data.length > 0) {
  //           this.registeredForms = data;
  //           console.log("regformsarray", this.registeredForms)
  //           for (var i = 0; i < data.length; i++) {
  //             if (data[i].name == 'Farmer Registration') {
  //               this.hideFarmerForm = true;
  //             } else if (data[i].name == 'Land Registration') {
  //               this.hideLandForm = true;
  //             } else if (data[i].name == 'Custom hiring centre') {
  //               this.hidechcForm = true;
  //             } else if (data[i].name == 'Farmer Bazar') {
  //               // this.hideserviceProvider = true
  //               this.hideFarmerbazar = true;
  //             } else if (data[i].name == 'Storage') {
  //               this.hidestorageForm = true;
  //             } else if (data[i].name == 'Crop Loan Request') {
  //               this.hideloanForm = true;
  //             } else if (data[i].name == 'Crop Insurance Request') {
  //               this.hideInsuranceForm = true;
  //             } else if (data[i].name.startsWith('Dealer')) {
  //               this.hidedealerForm = true;
  //             } else if (data[i].name.startsWith('Distributor')) {
  //               this.hidedistributorForm = true;
  //             } else if (data[i].name == 'Banker Registration') {
  //               this.hidebankerForm = true;
  //             } else if (data[i].name == 'Insurance Registration') {
  //               this.hideinsregForm = true;
  //             }
  //           }
  //           this.loading = false;
  //         } else {
  //           this.loading = false;
  //         }
  //       })
  //     } else {
  //       this.loading = false;
  //     }
  //   });
  // }

  registerForms() {
    this.showList = false;
  }

  addForms() {
    this.type = 'save'
    this.formsArray = [];
    this.editRow = []
    this.showStepper = true;
    this.registrationName = '';
    this.showList = false;
    this.registerForm = this.formBuilder.group({
      registrationName: ['', Validators.required],
      regLanguage: ['', Validators.required]
    });
    this.showAddform = true;
    this.isFormBtn = [];
    this.formTable = true;
    this.showSavebtn = true;
    this.showAdd = false;
    this.url = '';
    this.registerFormObj = { orderId: null, ask: '', type: '', response: '', kpi: false };
    this.registerFormUpdateObj = { orderId: null, ask: '', type: '', response: '', kpi: false };
    this.tableArray = [];
  }

  addFormQtns() {
    // this.type = 'update';
    this.editRow = [];
    this.isFormBtn = [];
    this.showAddform = true;
    this.formTable = true;
    this.showSavebtn = true;
    this.registerFormObj = { orderId: null, ask: '', type: '', response: '', kpi: false };
    this.registerFormUpdateObj = { orderId: null, ask: '', type: '', response: '', kpi: false };
    this.tableArray = [];
  }

  onChangeLanguage(lang) {
    console.log("language", lang);
  }

  EditRegisterData(index) {
    this.type = 'update'
    this.formsArray = []
    this.registerFormObj = { orderId: null, ask: '', type: '', response: '', kpi: false };
    this.registerGroup.reset();
    this.tableArray = [];
    this.showStepper = true;
    this.formTable = true;
    this.showList = false;
    this.isFormBtn = []
    this.showAddform = false;
    this.showAdd = false;
    this.showSavebtn = true;
    this.registrationName = this.registeredForms[index].name;
    this.url = this.globalImgUrl + this.registeredForms[index].icon;
    this.regLanguage = this.languageList.filter(item => item.shortName == this.registeredForms[index].language)[0].languageName;
    // this.imageUploadService = this.globalImgUrl + this.registeredForms[index].icon
    this.tableName = this.registeredForms[index].tableName;
    this.selectedUUID = this.registeredForms[index].uuid;
    console.log("selected data", this.registeredForms[index]);
    console.log("this.registerForms[index] ", this.registeredForms[index]);
    console.log("this.regLanguage ", this.regLanguage);
    for (var i = 0; i < this.registeredForms[index].Registrationforms.length; i++) {
      this.formsArray.push(this.registeredForms[index].Registrationforms[i])
    }
  }

  secondStep() {
    console.log("this.formsArray secondStep ", this.formsArray);
    if (this.formsArray.length > 0) {
      this.tableArray = [];
      this.formTable = false;
      this.isFormBtn = []
      this.showAddform = false;
      this.showAdd = true;
    } else
      this.showAddform = false;
  }

  //delete selected image
  deleteImage() {
    this.url = ''
  }

  goToForm() {
    this.showAdd = true;
  }

  deleteForm(index) {
    this.formsArray.splice(index, 1);
  }

  addData(event) {
    console.log("event : ", event)
  }

  OpenForms(forms, index) {
    this.isFormBtn = [];
    console.log("Forms : ", forms);
    this.tableArray = forms;
    this.showAddform = true;
    this.formTable = true;
    this.disableFormsBtn = false;
    this.index = index;
    this.isFormBtn[this.index] = true
    this.registerFormObj.orderId = this.tableArray.length + 1;
    console.log("this.isFormBtn ", this.tableArray);
    this.showSavebtn = false;
  }

  // SubmitAllForm() {
  //   let tablename = this.generateUID() + '_' + this.groupName;
  //   let language = this.languageList.filter(item => item.languageName == this.regLanguage)[0].shortName;
  //   this.loading = true;
  //   this.tableArray = [];
  //   this.isFormBtn = [];
  //   this.formTable = false;
  //   this.showSavebtn = false;
  //   this.register = {
  //     group: this.groupName,
  //     name: this.registrationName,
  //     icon: this.imageUploadService,
  //     tableName: tablename,
  //     language: language,
  //     Registrationforms: this.formsArray,
  //   }
  //   this.register['uuid'] = UUID.UUID();
  //   console.log("this.register ", this.register);
  //   if (this.registerIcon != undefined) {
  //     this.uploadFileToActivity();
  //   }
  //   this.registerService.pushRegistration(this.register).then((data: any) => {
  //     console.log("register data", JSON.stringify(data));
  //     if (data) {
  //       this.showStepper = false;
  //       this.formsArray = [];
  //       this.tableArray = [];
  //       this.url = '';
  //       this.showList = true;
  //       this.disableFormsBtn = false;
  //       this.registerForm.reset();
  //       this.getAllRegisteredForms();
  //     } else {
  //       this.loading = false;
  //       Swal.fire(
  //         'Error',
  //         'Data not Submitted (please contact admin)',
  //         'error'
  //       )
  //     }
  //   })
  // }

  // SubmitUpdateForm() {
  //   console.log("hhhh ", this.imageUploadService);
  //   let language = this.languageList.filter(item => item.languageName == this.regLanguage)[0].shortName;
  //   if (this.registerIcon != undefined) {
  //     this.uploadFileToActivity();
  //   }
  //   this.loading = true;
  //   this.tableArray = [];
  //   this.isFormBtn = [];
  //   this.formTable = false;
  //   this.showSavebtn = false;
  //   this.register = {
  //     group: this.groupName,
  //     name: this.registrationName,
  //     icon: this.imageUploadService,
  //     tableName: this.tableName,
  //     language: language,
  //     Registrationforms: this.formsArray,
  //   }
  //   console.log("this.tableName ", this.tableName);
  //   console.log("this.register ", this.register);
  //   this.registerService.updateRegistration(this.register, this.selectedUUID).then((data: any) => {
  //     // console.log("register update ", JSON.stringify(data));
  //     if (data) {
  //       this.showStepper = false;
  //       this.formsArray = [];
  //       this.tableArray = [];
  //       this.showList = true;
  //       this.disableFormsBtn = false;
  //       this.registerForm.reset();
  //       this.getAllRegisteredForms();
  //     } else {
  //       this.loading = false;
  //       Swal.fire(
  //         'Error',
  //         'Data not Submitted (please contact admin)',
  //         'error'
  //       )
  //     }
  //   })
  // }

  saveForm() {
    console.log("this.table array : ", this.tableArray);
    this.form = this.tableArray;
    this.formsArray.push(this.form);
    console.log("Farms Array : ", this.formsArray);
    this.tableArray = [];
    this.formTable = false;
    this.isFormBtn = [];
    this.editRow = [];
    this.showKpiNameUpdate = [];
    this.editRow[this.editRowIndex] = false;
    this.showKpiNameUpdate[this.editRowIndex] = false;
    this.kpinameHead = false;
    this.showAddform = false;
    this.showAdd = true;
  }

  removeTable() {
    this.registerFormObj = { orderId: null, ask: '', type: '', response: '', kpi: false };
    this.registerGroup.reset();
    this.showKpiName = false;
  }

  insertIntoTable() {
    console.log("inertIntoTable : ", this.registerFormObj);
    if ((this.registerFormObj.type == 'singleSelect') || (this.registerFormObj.type == 'multiSelect') || (this.registerFormObj.type == 'dropdown')) {
      this.registerFormObj['responseArray'] = this.registerFormObj.response.split(',');
    }
    console.log("inertIntoTable registerFormObj : ", this.registerFormObj);
    if (this.registerFormObj.kpi && this.registerFormObj.kpi == true) {
      if (this.kpiName != null && this.kpiName != '' && this.kpiName != undefined) {
        this.registerFormObj['kpiName'] = this.kpiName;
        let index = this.tableArray.findIndex(x => x.orderId == this.registerFormObj.orderId);
        let KPI = this.tableArray.findIndex(x => x.kpiName == this.registerFormObj.kpiName);
        console.log("KPI ", KPI)
        if (index === -1 && KPI === -1) {
          this.tableArray.push(this.registerFormObj);
          console.log("tableArray : ", this.tableArray);
          this.tableArray.sort((a, b) => Number(a.orderId) - Number(b.orderId));
          console.log("this.tableArray sorted ", this.tableArray)
          this.registerFormObj = { orderId: null, ask: '', type: '', response: '', kpi: false };
          this.registerGroup.reset();
          this.showKpiName = false;
          this.registerFormObj.orderId = this.tableArray.length + 1;
        } else {
          Swal.fire(
            'Error',
            'Order Id or Kpi name is already exist',
            'error'
          )
        }
      } else {
        Swal.fire(
          'Error',
          'Add kpi name',
          'error'
        )
      }
    } else {
      let index = this.tableArray.findIndex(x => x.orderId == this.registerFormObj.orderId);
      if (index === -1) {
        this.tableArray.push(this.registerFormObj);
        console.log("tableArray : ", this.tableArray);
        this.tableArray.sort((a, b) => Number(a.orderId) - Number(b.orderId));
        console.log("this.tableArray sorted ", this.tableArray)
        this.registerFormObj = { orderId: null, ask: '', type: '', response: '', kpi: false };
        this.registerGroup.reset();
        this.showKpiName = false;
        this.registerFormObj.orderId = this.tableArray.length + 1;
      } else {
        Swal.fire(
          'Error',
          'Order Id is already exist',
          'error'
        )
      }
    }
  }

  backToAddForm() {
    this.showAddform = false;
    // this.registerGroup.reset();
  }

  editRowData(index) {
    this.showKpiNameUpdate = [];
    this.kpinameHead = false;
    this.disableFormsBtn = true;
    console.log(this.tableArray[index]);
    if (this.tableArray[index].kpi) {
      this.showKpiNameUpdate[index] = true;
      this.kpinameHead = true
    }
    this.registerFormUpdateObj = { orderId: null, ask: '', type: '', response: '', kpi: false };
    this.registerGroup.reset();
    this.editRow = [];
    this.editRow[index] = true;
    this.editRowIndex = index;
    this.registerFormUpdateObj.orderId = this.tableArray[index].orderId;
    this.registerFormUpdateObj.ask = this.tableArray[index].ask;
    this.registerFormUpdateObj.kpi = this.tableArray[index].kpi;
    if (this.tableArray[index].kpi) {
      this.registerFormUpdateObj['kpiName'] = this.tableArray[index].kpiName;
    }
    this.registerFormUpdateObj.response = this.tableArray[index].response;
    this.registerFormUpdateObj.type = this.tableArray[index].type;
  }

  cancelRowEdit(index) {
    this.showKpiNameUpdate = [];
    this.disableFormsBtn = false;
    this.kpinameHead = false
    this.editRow = [];
    this.editRow[index] = false;
    this.editRowIndex = index;
  }

  onChangeKpi(event) {
    console.log("d ", event);
    if (event.currentValue) {
      this.showKpiName = true;
    } else this.showKpiName = false;
  }

  onChangeKpiUpdate(event, i) {
    this.showKpiNameUpdate = []
    if (event.currentValue) {
      this.registerFormUpdateObj.kpi = true
      this.showKpiNameUpdate[i] = true;
      this.kpinameHead = true
    } else {
      this.registerFormUpdateObj.kpi = false
      this.showKpiNameUpdate[i] = false;
      this.kpinameHead = false
    }
  }

  updateRow(index) {
    this.editRowIndex = index;
    this.disableFormsBtn = false;
    console.log("this.registerFormUpdateObj ", this.registerFormUpdateObj);
    if (this.registerFormUpdateObj.kpi) {
      console.log("kpi name ", this.registerFormUpdateObj.hasOwnProperty("kpiName"))
      if (this.registerFormUpdateObj.hasOwnProperty("kpiName")) {
        this.kpinameHead = false;
        this.showKpiNameUpdate = [];
        if ((this.registerFormUpdateObj.type == 'singleSelect') || (this.registerFormUpdateObj.type == 'multiSelect') || (this.registerFormUpdateObj.type == 'dropdown')) {
          this.registerFormUpdateObj['responseArray'] = this.registerFormUpdateObj.response.split(',');
        }
        let i = this.tableArray.findIndex(x => x.orderId == this.registerFormUpdateObj.orderId);
        console.log("index: ", index, i);
        if (i === index) {
          this.editRow = [];
          this.editRow[index] = false;
          this.tableArray[index] = this.registerFormUpdateObj;
          this.tableArray.sort((a, b) => Number(a.orderId) - Number(b.orderId));
          this.registerFormUpdateObj = { orderId: null, ask: '', type: '', response: '', kpi: false };
        } else if (i === -1) {
          this.editRow = [];
          this.editRow[index] = false;
          this.tableArray[index] = this.registerFormUpdateObj;
          this.tableArray.sort((a, b) => Number(a.orderId) - Number(b.orderId));
          this.registerFormUpdateObj = { orderId: null, ask: '', type: '', response: '', kpi: false };
        } else {
          Swal.fire(
            'Error',
            'Order Id is already exist',
            'error'
          )
        }
      } else {
        Swal.fire(
          'Error',
          'Enter kpi name',
          'error'
        )
      }
    } else {
      this.kpinameHead = false;
      this.showKpiNameUpdate = [];
      console.log("this.registerFormUpdateObj ", this.registerFormUpdateObj);
      if ((this.registerFormUpdateObj.type == 'singleSelect') || (this.registerFormUpdateObj.type == 'multiSelect') || (this.registerFormUpdateObj.type == 'dropdown')) {
        this.registerFormUpdateObj['responseArray'] = this.registerFormUpdateObj.response.split(',');
      }
      let i = this.tableArray.findIndex(x => x.orderId == this.registerFormUpdateObj.orderId);
      console.log("index: ", index, i);
      if (i === index) {
        this.editRow = [];
        this.editRow[index] = false;
        this.tableArray[index] = this.registerFormUpdateObj;
        this.tableArray.sort((a, b) => Number(a.orderId) - Number(b.orderId));
        this.registerFormUpdateObj = { orderId: null, ask: '', type: '', response: '', kpi: false };
      } else if (i === -1) {
        this.editRow = [];
        this.editRow[index] = false;
        this.tableArray[index] = this.registerFormUpdateObj;
        this.tableArray.sort((a, b) => Number(a.orderId) - Number(b.orderId));
        this.registerFormUpdateObj = { orderId: null, ask: '', type: '', response: '', kpi: false };
      } else {
        Swal.fire(
          'Error',
          'Order Id is already exist',
          'error'
        )
      }
    }
  }

  onClickTab(id) {
    this.showReg = true;
    if (id == 'dynamic') {
      this.typeId = 'dynamic';
    } else if (id == 'static') {
      this.typeId = 'static';
    }
  }

  backStaticReg() {
    this.showReg = true;
  }

  viewRegisterForm(type) {
    this.selctedReg = type;
    this.showReg = false;
  }

  deleteRow(index) {
    this.kpinameHead = false;
    this.showKpiNameUpdate = []
    console.log("Deleted!");
    this.tableArray.splice(index, 1);
  }

  // BackToFormsList() {
  //   this.tableArray = [];
  //   this.formTable = false;
  //   this.isFormBtn = []
  //   this.showAddform = false;
  //   this.showAdd = true;
  //   this.getAllRegisteredForms();
  // }
  // backToView() {
  //   this.showStepper = false;
  //   this.showList = true;
  //   this.getAllRegisteredForms();
  // }

  imageInput(event) {
    console.log("event : ", event);
    if (event.target.files[0].type == 'image/png') {
      if (event.target.files && event.target.files[0]) {
        // this.registerIcon = event.target.files[0].name
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]); // read file as data url
        reader.onload = (event: any) => { // called once readAsDataURL is completed
          this.url = event.target.result;
        }
        let iuuid = UUID.UUID();
        this.imageUploadService = 'reg_' + iuuid + "." + event.target.files.item(0).type.split('/')[1];
        this.registerIcon = event.target.files[0]
        console.log("ricon", this.registerIcon)
      }
    }
  }

  updateForm() {
    console.log("updateForm data : ", this.tableArray);
    this.form = this.tableArray;
    this.formsArray[this.index] = this.form;
    console.log("updateForm Array : ", this.formsArray);
    this.tableArray = [];
    this.showAddform = false;
    this.formTable = false;
    this.isFormBtn = [];
    this.editRow = [];
    this.showKpiNameUpdate = [];
    this.editRow[this.editRowIndex] = false;
    this.showKpiNameUpdate[this.editRowIndex] = false;
    this.kpinameHead = false;
  }

  handleInput(e) {
    // console.log("event.which ", e)
    if (e.which === 32 && e.target.selectionStart === 0) {
      return false;
    }
  }

  uploadFileToActivity() {
    console.log("dd ", this.imageUploadService, this.registerIcon)
    if (this.registerIcon != '') {
      // this.registerService.postFile(this.registerIcon, this.imageUploadService).then(data => {
      // }, error => {
      //   console.log(error);
      // });
      this.fileUploadService.uploadFile(this.registerIcon, this.imageUploadService);
    }
  }

  generateUID() {
    // I generate the UID from two parts here 
    // to ensure the random number provide enough bits.
    var firstPart = (Math.random() * 46656) | 0;
    var secondPart = (Math.random() * 46656) | 0;
    var first = ("000" + firstPart.toString(36)).slice(-3);
    var second = ("000" + secondPart.toString(36)).slice(-3);
    return first + second;
  }

  // addRegisterForm(type) {
  //   console.log("this.generateUID ", this.generateUID())
  //   if (type == 'farmer') {
  //     let farmerArr = [];
  //     farmerArr.push(this.farmerObject);
  //     let obj = {
  //       group: this.groupName,
  //       name: "Farmer Registration",
  //       icon: "reg_6dcb9b90-88a4-9232-e79a-9fe9f7f1f0f1.png",
  //       tableName: 'farmer',
  //       language: 'EN',
  //       Registrationforms: farmerArr,
  //       uuid: UUID.UUID()
  //     }
  //     this.registerService.pushRegistration(obj).then((data: any) => {
  //       // console.log("farmerRegAdded",JSON.stringify(data))
  //       this.getAllRegisteredForms();
  //     })
  //     // console.log("farmer results == ",JSON.stringify(this.farmerObject))
  //   } else if (type == 'land') {
  //     let landArr = [];
  //     for (var i = 0; i < this.landObject.length; i++) {
  //       landArr.push(this.landObject[i])
  //     }
  //     let lobj = {
  //       group: this.groupName,
  //       name: "Land Registration",
  //       icon: "reg_8a2e8899-fecd-1997-f7a3-78e6a6b57cad.png",
  //       tableName: 'land',
  //       language: 'EN',
  //       Registrationforms: landArr,
  //       uuid: UUID.UUID()
  //     }
  //     this.registerService.pushRegistration(lobj).then((data: any) => {
  //       this.getAllRegisteredForms();
  //     })
  //     // console.log("land results == ",JSON.stringify(this.landObject))
  //   } else if (type == 'chc') {
  //     let chcList = [];
  //     for (var i = 0; i < this.chcObject.length; i++) {
  //       chcList.push(this.chcObject[i])
  //     }
  //     let lobj = {
  //       group: this.groupName,
  //       name: "Custom hiring centre",
  //       icon: "reg_af01a0a6-f57d-4c8b-2f09-6523b8c7973a.png",
  //       tableName: 'chc',
  //       language: 'EN',
  //       Registrationforms: chcList,
  //       uuid: UUID.UUID()
  //     }
  //     this.registerService.pushRegistration(lobj).then((data: any) => {
  //       this.getAllRegisteredForms();
  //     })
  //   } else if (type == 'farmmachine') {
  //     let machineList = [];
  //     for (var i = 0; i < this.farmmachineObject.length; i++) {
  //       machineList.push(this.farmmachineObject[i])
  //     }
  //     let lobj = {
  //       group: this.groupName,
  //       name: "Farm machinery",
  //       icon: "machinereg.png",
  //       language: 'EN',
  //       tableName: 'farmmachine_' + this.groupName,
  //       Registrationforms: machineList,
  //       uuid: UUID.UUID()
  //     }
  //     this.registerService.pushRegistration(lobj).then((data: any) => {
  //       this.getAllRegisteredForms();
  //     })
  //   }
  //   // } else if (type == 'serviceprovider') {

  //   //   let serviceProviderList = [];
  //   //   for (var i = 0; i < this.serviceproviderObject.length; i++) {
  //   //     serviceProviderList.push(this.serviceproviderObject[i])
  //   //   }

  //   //   let sobj = {
  //   //     group: this.groupName,
  //   //     name: "Service provider",
  //   //     icon: "serviceprovider.png",
  //   //     tableName: 'serviceprovider_',
  //   //     Registrationforms: serviceProviderList
  //   //   }
  //   //   this.registerService.pushRegistration(sobj).then((data: any) => {
  //   //     this.getAllRegisteredForms();
  //   //   });
  //   // }
  //   else if (type == 'farmerBazar') {
  //     let farmerBazar = [];
  //     for (var i = 0; i < this.bazarObject.length; i++) {
  //       farmerBazar.push(this.bazarObject[i])
  //     }
  //     let bobj = {
  //       group: this.groupName,
  //       name: "Farmer Bazar",
  //       icon: "reg_1f5a8bf2-746d-bf70-d33a-4ce608ce371a.png",
  //       tableName: 'farmerBazar',
  //       language: 'EN',
  //       Registrationforms: farmerBazar,
  //       uuid: UUID.UUID()
  //     }
  //     this.registerService.pushRegistration(bobj).then((data: any) => {
  //       this.getAllRegisteredForms();
  //     });
  //   }
  //   else if (type == 'storage') {
  //     let storage = [];
  //     for (var i = 0; i < this.storageObject.length; i++) {
  //       storage.push(this.storageObject[i])
  //     }
  //     let sobj = {
  //       group: this.groupName,
  //       name: "Storage",
  //       icon: "reg_15e70f26-ff91-24a2-0545-0b4fcc897bba.png",
  //       tableName: 'storage',
  //       language: 'EN',
  //       Registrationforms: storage,
  //       uuid: UUID.UUID()
  //     }
  //     this.registerService.pushRegistration(sobj).then((data: any) => {
  //       this.getAllRegisteredForms();
  //     })
  //   } else if (type == 'loan') {
  //     let loan = [];
  //     for (var i = 0; i < this.loanObject.length; i++) {
  //       loan.push(this.loanObject[i])
  //     }
  //     let lobj = {
  //       group: this.groupName,
  //       name: "Crop Loan Request",
  //       icon: "croploanrequest.png",
  //       tableName: 'croploanrequest',
  //       language: 'EN',
  //       Registrationforms: loan,
  //       uuid: UUID.UUID()
  //     }
  //     this.registerService.pushRegistration(lobj).then((data: any) => {
  //       this.getAllRegisteredForms();
  //     })
  //   } else if (type == 'insurance') {
  //     let insurance = [];
  //     for (var i = 0; i < this.insuranceObject.length; i++) {
  //       insurance.push(this.insuranceObject[i])
  //     }
  //     let iobj = {
  //       group: this.groupName,
  //       name: "Crop Insurance Request",
  //       icon: "cropinsurancerequest.png",
  //       tableName: 'cropinsurancerequest',
  //       language: 'EN',
  //       Registrationforms: insurance,
  //       uuid: UUID.UUID()
  //     }
  //     this.registerService.pushRegistration(iobj).then((data: any) => {
  //       this.getAllRegisteredForms();
  //     })
  //   } else if (type == 'dealer') {
  //     let dealer = [];
  //     for (var i = 0; i < this.dealerObject.length; i++) {
  //       dealer.push(this.dealerObject[i])
  //     }
  //     let dobj = {
  //       group: this.groupName,
  //       name: "Dealer Registration",
  //       icon: "reg_d4840af6-0345-44db-d528-98bae56955ed.png",
  //       tableName: 'dealer',
  //       language: 'EN',
  //       Registrationforms: dealer,
  //       uuid: UUID.UUID()
  //     }
  //     this.registerService.pushRegistration(dobj).then((data: any) => {
  //       this.getAllRegisteredForms();
  //     })
  //   }
  //   else if (type == 'distributor') {
  //     let distributor = [];
  //     for (var i = 0; i < this.distributorObject.length; i++) {
  //       distributor.push(this.distributorObject[i])
  //     }
  //     let dobj = {
  //       group: this.groupName,
  //       name: "Distributor Registration",
  //       icon: "reg_80dfd630-ccd3-6fdb-36b9-e51013b6c863.png",
  //       tableName: 'distributor',
  //       language: 'EN',
  //       Registrationforms: distributor,
  //       uuid: UUID.UUID()
  //     }
  //     this.registerService.pushRegistration(dobj).then((data: any) => {
  //       this.getAllRegisteredForms();
  //     })
  //   }
  //   else if (type == 'banker') {
  //     let banker = [];
  //     for (var i = 0; i < this.bankerObject.length; i++) {
  //       banker.push(this.bankerObject[i])
  //     }
  //     let bobj = {
  //       group: this.groupName,
  //       name: "Banker Registration",
  //       icon: "reg_58af2c24-2c9b-f424-c3b1-a6a635a19730.png",
  //       tableName: 'bankerregistration',
  //       language: 'EN',
  //       Registrationforms: banker,
  //       uuid: UUID.UUID()
  //     }
  //     this.registerService.pushRegistration(bobj).then((data: any) => {
  //       this.getAllRegisteredForms();
  //     })
  //   }
  //   else if (type == 'insuranceReg') {
  //     let insuranceRegistration = [];
  //     for (var i = 0; i < this.insuranceregObject.length; i++) {
  //       insuranceRegistration.push(this.insuranceregObject[i])
  //     }
  //     let robj = {
  //       group: this.groupName,
  //       name: "Insurance Registration",
  //       icon: "reg_70d83a05-04e2-79f8-5d53-ebedacd9db20.png",
  //       tableName: 'insuranceregistration',
  //       language: 'EN',
  //       Registrationforms: insuranceRegistration,
  //       uuid: UUID.UUID()
  //     }
  //     this.registerService.pushRegistration(robj).then((data: any) => {
  //       this.getAllRegisteredForms();
  //     })
  //   }
  // }
}
